export function findIncludesReferences(array, includes) {
    return array.map((data) => findIncludesReference(data.sys.id, includes));
}

export function findIncludesReference(id, entries) {
    return entries.find((item) => item.sys.id === id);
}

export function isNumber(value) {
    return typeof value === "number" && !isNaN(value);
}

export function convertArrayToKeyValue(arr) {
    return arr.map((value) => {
        return {
            key: value.trim().toLowerCase(),
            value: value,
        };
    });
}

export function capitalizeString(value) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

// Maps a construction year (e.g. 1750 or "1750") to the Contentful era id ("1000", "1600", ... "2000")
export function getEraIdFromYear(activeEra) {
    const YearInTen = parseInt(String(activeEra).slice(0,2), 0);

    let year = 1000;

    // Setts the ID refrence to contentful
    if (YearInTen < 16) year = "1000";
    else if (YearInTen === 16) year = "1600";
    else if (YearInTen === 17) year = "1700";
    else if (YearInTen === 18) year = "1800";
    else if (YearInTen === 19) year = "1900";
    else if (YearInTen === 20) year = "2000";

    return year;
}

export function updateCanonicalLink(){
    const canonicalUrl = window.location.origin + window.location.pathname; // Dynamically set this if needed
    let link = document.querySelector("link[rel='canonical']");

    if (link) {
        // Update existing canonical tag
        link.setAttribute('href', canonicalUrl);
    } else {
        // Create a new one
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', canonicalUrl);
        document.head.appendChild(link);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/helpers.js